import { Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'four-oh-one',
  templateUrl: './four-oh-one.component.html',
  standalone: false,
})
export class FourOhOneComponent {
  @Input() returnToUrl: string;
  @Input() user: any;

  // return_to is a URL inside a URL, so its own ? and & must be encoded.
  get loginHref(): string {
    return `/login?return_to=${encodeURIComponent(this.returnToUrl || '')}`;
  }
}
